
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1101Dialog extends Serenity.EntityDialog<Report_1101Row, any> {
        protected getFormKey() { return Report_1101Form.formKey; }
        protected getIdProperty() { return Report_1101Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1101Row.localTextPrefix; }
        protected getNameProperty() { return Report_1101Row.nameProperty; }
        protected getService() { return Report_1101Service.baseUrl; }
        protected getDeletePermission() { return Report_1101Row.deletePermission; }
        protected getInsertPermission() { return Report_1101Row.insertPermission; }
        protected getUpdatePermission() { return Report_1101Row.updatePermission; }

        protected form = new Report_1101Form(this.idPrefix);

    }
}